import { Row } from "@faire/web/slate/Layout";
import React, { type JSX } from "react";
import styled, { css } from "styled-components";

import { NUM_ROWS_OF_SWATCHES } from "@faire/retailer/views/product/ProductDetails/AddToCart/OptionSelection/SpecialOptionPicker";

const SWATCH_HEIGHT = 52;

export const OptionsRow: React.FC<{
  isSwatchPicker: boolean;
  shouldShowAllSwatches: boolean;
  totalNumRowsOfSwatches: number;
  options?: JSX.Element[];
}> = ({
  isSwatchPicker,
  shouldShowAllSwatches,
  totalNumRowsOfSwatches,
  options,
}) => {
  if (isSwatchPicker) {
    return (
      <SwatchOptionRow
        $expanded={shouldShowAllSwatches}
        $numRows={totalNumRowsOfSwatches}
        role="radiogroup"
      >
        {options}
      </SwatchOptionRow>
    );
  }
  return <OptionRow role="radiogroup">{options}</OptionRow>;
};

const SwatchOptionRow = styled.div<{
  $expanded: boolean;
  $numRows: number;
}>`
  overflow: hidden;
  transition: height 1s;
  ${(props) => {
    return css`
      display: grid;
      grid-template-columns: repeat(auto-fill, 48px);
      justify-content: space-between;
      ${props.$expanded
        ? css`
            height: ${props.$numRows * SWATCH_HEIGHT}px;
          `
        : css`
            height: ${Math.min(NUM_ROWS_OF_SWATCHES, props.$numRows) *
            SWATCH_HEIGHT}px;
          `}
    `;
  }};
`;

const OptionRow = styled(Row).attrs({ gap: 4 })`
  overflow: hidden;
  position: relative;
  flex-wrap: wrap;
`;
